module.exports = __webpack_public_path__ + "static/media/background-tile.18b34215.jpeg";